module.exports = __webpack_public_path__ + "assets/img/google.67913c76.png";